import React, { Component } from 'react';
import styles from './styles';
import _ from 'lodash';

class AxlTabs extends Component {
  render () {
    return (<div style={ styles.container }>
        {this.props.children}
    </div>)
  }

  static SectionTitle = class extends Component {
    render() {
      return <div style={styles.sectionTitle}>
        {this.props.children}
      </div>
    }
  }

  static PanelTitle = class extends Component {
    render() {
      const panelTitleStyle = this.props.active ? styles.panelTitleActive : styles.panelTitle
      //inject attributes
      const props = _.omit(this.props, ['active']);

      return <h3 style={panelTitleStyle} {...props}>
        {this.props.children}
      </h3>
    }
  }

  static PanelContent = class extends Component {
    render() {
      const { active } = this.props

      return active ? <div style={styles.panelContent}>
        {this.props.children}
      </div> : null
    }
  }
}

export default AxlTabs